import CommissionDetails from "./CommissionDetails";

export default CommissionDetails;